module.exports = __webpack_public_path__ + "static/media/12.9adb9c3d.jpg";